export type OcclusionRect={x:number;y:number;width:number;height:number};
export type ProtectedActor={id:string;depth:number;bounds:OcclusionRect};
export function propOcclusion(prop:{depth:number;bounds:OcclusionRect;opacity:number;fade:number},actors:readonly ProtectedActor[]):{alpha:number;coveredBy:string[]}{
 const a=prop.bounds,coveredBy=actors.filter(actor=>{const b=actor.bounds;return prop.depth>actor.depth&&a.x<b.x+b.width&&a.x+a.width>b.x&&a.y<b.y+b.height&&a.y+a.height>b.y;}).map(actor=>actor.id);
 return{alpha:coveredBy.length?Math.min(prop.opacity,Math.max(0,Math.min(1,prop.fade))):prop.opacity,coveredBy};
}
